<template>
  <div class="row spinner-parent">
    <spinner ref="spinner" size="md" text="Loading ..." />

    <div v-if="source" class="col-12">
      <div class="card">
        <div class="card-header">
          <h1>
            {{ source.title }}
            <open-on-site
              :source-route="source.route"
            />
            <button class="btn btn-danger btn-sm" @click="$_deleteEntity(`media/video/${source.id}`)">
              Delete
              <span ref="deleteBtnLoader" class="btn-loader" style="display: none;" />
            </button>
          </h1>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>General</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="title" class="col-md-2">Title *</label>
                  <div class="col-md-10">
                    <input
                      id="title"
                      v-model="entity.title"
                      type="text"
                      placeholder="Enter title"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="body" class="col-md-2">Body *</label>
                  <div class="col-md-10">
                    <ckeditor id="body" v-model="entity.body" />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="summary" class="col-md-2">Summary</label>
                  <div class="col-md-10">
                    <ckeditor id="summary" v-model="entity.summary" />
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-12">
                    <div class="form-group row">
                      <label for="body" class="col-md-2 form-control-label">File/Link *</label>
                      <div class="col-md-10">
                        <FileUploader
                          v-model="videoFile"
                          check-type="media_video"
                          path-prefix="vid"
                          :default-file="entity.mediaFile"
                          :default-files="defaultFiles"
                          :dropzone-options="dropzoneOptions"
                          :vimeo="source.vimeo_link ? source.vimeo_link.link : ''"
                          :youtube="source.youtube_link ? source.youtube_link.link : ''"
                          :start-type="startVideoType"
                          :uploaded-files-dictionary="uploadedFilesDictionary"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label for="bio" class="col-md-2">Thumbnail</label>
                  <div class="col-md-10">
                    <image-uploader
                      :uploaded-img-url="coverUrl"
                      @changeFile="changeCover"
                      @returnedOldFile="coverRestore"
                      @existingFileRemoved="coverRemove"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="bio" class="col-md-2">Video Series</label>
                  <div class="col-md-10">
                    <select-remote
                      v-model="entity.series"
                      :default-options="defaultOptions.series"
                      :search-function="seriesSearch"
                      label="title"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="published" class="col-md-2">Published</label>
                  <div class="col-md-10">
                    <input id="published" v-model="entity.published" type="checkbox">
                  </div>
                </div>

                <div class="form-group row">
                  <label for="featured" class="col-md-2">Featured Content</label>
                  <div class="col-md-10">
                    <select id="featured" v-model="entity.featured.section_id" class="form-control" name="featured">
                      <option v-for="(item, key) in $_featuredBlocksList" :key="item" :value="key">
                        {{ item }}
                      </option>
                    </select>
                  </div>
                </div>

                <div v-if="entity.featured.section_id && entity.featured.section_id > 0" class="form-group row">
                  <label for="bio" class="col-md-2">Featured Summary</label>
                  <div class="col-md-10">
                    <ckeditor id="featured_body" v-model="entity.featured.featured_body" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>SEO</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="seo_title" class="col-md-2">Title</label>
                  <div class="col-md-10">
                    <input
                      id="seo_title"
                      v-model="entity.seo_title"
                      type="text"
                      placeholder="Enter SEO title"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Description</label>
                  <div class="col-md-10">
                    <textarea id="seo_desc" v-model="entity.seo_description" class="form-control" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <referencer
        :already-choosen-refs="entity.loadedReferences"
        @changeRefs="$_changeRefs"
      />

      <terms
        :already-choosen-terms="entity.terms"
        @changeTerms="$_changeTerms"
      />

      <div class="card">
        <div class="card-header">
          <strong>Path Alias</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="path_alias" class="col-md-2">{{ $config.app_api.host }}</label>
                  <div class="col-md-10">
                    <input
                      id="path_alias"
                      v-model="entity.path_alias.path_alias"
                      type="text"
                      placeholder="Enter path alias"
                      class="form-control"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-5">
        <button class="btn btn-success" @click="save">
          Save
          <span class="btn-loader" style="display: none;" />
        </button>

        <div class="saving-alerts" style="margin-top: 20px;">
          <div class="alert alert-success" style="display: none;">
            Video has modified successful!
          </div>
          <div class="alert alert-danger" style="display: none;">
            {{ saveErrorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import axios from 'axios';
import FileUploader from '@/global/components/FileUploader/Index';
import { URL, FILE } from '@/global/components/FileUploader/constants';
import SelectRemote from '@/global/components/SelectRemote';
import Referencer from '@/global/components/Referencer';
import Terms from '@/global/components/TermsEditor';
import OpenOnSiteButton from '@/global/components/OpenOnSiteButton';
import { uploadStatus } from '@/helpers/constants';
import config from '../../../config';
// Mixins
import EditPageMixin from '@/mixins/EditPageMixin';
import DefaultOptionsRequests from '@/mixins/DefaultOptionsRequests';
import CommonPageMixin from '@/mixins/CommonPageMixin';

const { SUCCESS } = uploadStatus;

export default {
  name: 'VideoEdit',

  components: {
    'select-remote': SelectRemote,
    'open-on-site': OpenOnSiteButton,
    FileUploader,
    referencer: Referencer,
    terms: Terms,
  },

  mixins: [EditPageMixin, DefaultOptionsRequests, CommonPageMixin],

  data() {
    return {
      videoFile: {
        uploadType: 'file',
        fileLink: '',
        file: null,
        filesDictionary: {},
      },
      dropzoneSettings: {
        maxFiles: 1,
        maxFilesize: 10240,
      },
      uploadedFilesDictionary: {},
      defaultFiles: {},
      qualityArray: [
        144,
        240,
        360,
        480,
        720,
        1080,
      ],
    };
  },

  computed: {
    startVideoType() {
      if (!this.source) return 'file';
      if (this.source.vimeo_link && this.source.vimeo_link.active) return 'vimeo';
      if (this.source.youtube_link && this.source.youtube_link.active) return 'youtube';
      return 'file';
    },
    coverUrl() {
      if (!this.source) return null;
      if (Object.prototype.hasOwnProperty.call(this.source, 'cover') && this.source.cover) {
        return this.source.cover.public_url;
      }
      return null;
    },
    coverIsChanged() {
      if (!this.source.cover) {
        return !!this.entity.cover;
      }
      if (_.isObject(this.entity.cover) && this.entity.cover.id === this.source.cover.id) {
        return false;
      }
      return true;
    },
    dropzoneOptions() {
      return {
        headers: {
          Authorization: `Bearer ${this.$store.state.user.accessToken.access_token}`,
          Accept: 'application/json',
        },
        method: 'POST',
        paramName: 'mediaFile',
        autoProcessQueue: false,
        url: `${this.$config.app_api.host}${this.$config.app_api.prefix}media/video/${this.$route.params.id}/file`,
        maxFilesize: this.dropzoneSettings.maxFilesize,
        maxFiles: this.dropzoneSettings.maxFiles,
        acceptedFiles: 'video/*,video/x-matroska,.mkv',
        addRemoveLinks: true,
        dictRemoveFileConfirmation: 'Do you really want to remove this file?',
      };
    },
    uploadingFiles() {
      const getUploadsList = this.$store.getters['uploadManager/getUploadsList'];
      if (!getUploadsList) {
        return [];
      }
      return getUploadsList(this.$route.params.id, 'media_video').filter(item => item.status === SUCCESS);
    },
  },

  watch: {
    uploadingFiles: {
      handler(val) {
        if (val.length) {
          val.forEach((file) => {
            this.uploadedFilesDictionary[file.quality] = file.file;
            this.uploadedFilesDictionary = {
              ...this.uploadedFilesDictionary,
            };
          });
        }
      },
      deep: true,
    },
  },

  mounted() {
    this.$_getDefaultSeries();
    this.uploadedFilesDictionary = { ...this.videoFile.filesDictionary };
  },

  methods: {
    seriesSearch: _.debounce((loading, search, vm, searchRequestId) => {
      const context = vm;
      vm.$apiHttp.get(`${vm.$config.app_api.prefix}media/video-series?search_string=${escape(search)}`)
        .then((response) => {
          if (!vm.searchQuery || vm.searchRequestId !== searchRequestId) return;
          const newDataArr = _.cloneDeep(response.data);
          delete newDataArr.meta;
          context.options = Object.keys(newDataArr).map(e => newDataArr[e]);
          loading(false);
        })
        .catch((error) => {
          loading(false);
          console.error(error);
        });
    }, 350),
    changeCover(file) {
      this.entity.cover = file;
    },
    coverRestore() {
      this.entity.cover = this.source.cover;
    },
    coverRemove() {
      this.entity.cover = null;
    },
    isEntityValid() {
      return this.$_validate([
        { name: 'Title', value: this.entity.title, type: 'required' },
        { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 },
        { name: 'Path Alias', value: this.entity.path_alias.path_alias, type: 'path' },
      ]);
    },
    getSource() {
      if (this.$refs.spinner) { this.$refs.spinner.show(); }
      this.$apiHttp.get(`${this.$config.app_api.prefix}media/video/${this.$route.params.id}`, {
        params: {
          with: [
            'terms',
            'references',
            'mediaFile',
            'path_alias',
            'cover',
            'series',
            'featured',
            'video_144_p',
            'video_240_p',
            'video_360_p',
            'video_480_p',
            'video_720_p',
            'video_1080_p',
          ],
        },
      }).then((response) => {
        this.source = this.$_apadtSource(response.data);
        if (!Object.prototype.hasOwnProperty.call(this.source, 'cover')) {
          this.source.cover = null;
        }
        this.entity = _.cloneDeep(this.source);
        if (this.$refs.spinner) { this.$refs.spinner.hide(); }
        this.qualityArray.forEach((quality) => {
          const item = this.entity[`video_${quality}_p`];
          if (item) {
            this.defaultFiles[quality] = item;
          }
        });
      }).catch((error) => {
        if (this.$refs.spinner) { this.$refs.spinner.hide(); }
        this.$store.dispatch('notifications/setHttpError', { error, text: 'Error in getting video request' });
        console.error('Error in get single video query', error);
      });
    },
    saveRequest() {
      const postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('body', this.entity.body ? this.entity.body : '');
      postFormData.append('series_id', this.entity.series ? this.entity.series.id : '');
      // postFormData.append('selectel_file_url', this.videoFile.fileLink);
      const { filesDictionary } = this.videoFile;
      if (this.videoFile.youtube) {
        postFormData.append('youtube_link', JSON.stringify({
          link: this.videoFile.youtube,
          active: this.videoFile.uploadType === 'youtube',
        }));
      } else {
        postFormData.append('youtube_link', '');
      }
      if (this.videoFile.vimeo) {
        postFormData.append('vimeo_link', JSON.stringify({
          link: this.videoFile.vimeo,
          active: this.videoFile.uploadType === 'vimeo',
        }));
      } else {
        postFormData.append('vimeo_link', '');
      }
      this.qualityArray.forEach((quality) => {
        if (filesDictionary[quality].type === URL && filesDictionary[quality].linkStatus === 'ok') {
          postFormData.append(`selectel_file_url_${quality}`, filesDictionary[quality].url);
        }
      });
      postFormData.append('featured', this.entity.featured.section_id ? this.entity.featured.section_id : '');
      postFormData.append('featured_body', this.entity.featured.featured_body);
      return this.$apiHttp.post(`${this.$config.app_api.prefix}media/video/${this.$route.params.id}`, postFormData);
    },
    saveCoverRequest() {
      const postFormData = new FormData();
      postFormData.append('cover', this.entity.cover);
      return this.$apiHttp.post(
        `${this.$config.app_api.prefix}media/video/${this.$route.params.id}/cover`,
        postFormData,
      );
    },
    deleteCoverRequest() {
      return this.$apiHttp.delete(`${this.$config.app_api.prefix}media/video/${this.$route.params.id}/cover`);
    },
    saveMediaFileRequest() {
      const postFormData = new FormData();
      if (this.videoFile.uploadType === 'file') {
        postFormData.append('chunkedFile', true);
      }
      return this.$apiHttp.post(
        `${this.$config.app_api.prefix}media/video/${this.$route.params.id}/file`,
        postFormData,
      );
    },
    save() {
      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      const { filesDictionary } = this.videoFile;
      const { uploadedFilesDictionary } = this;
      const dicKeys = Object.keys(filesDictionary);
      const { prefix, host } = this.$config.app_api;
      const token = JSON.parse(localStorage.getItem(config.tokenStorage.name));
      const { acceptedFiles } = this.dropzoneOptions;
      const dispatchStartUpload = (contentType) => {
        if (dicKeys.length && filesDictionary) {
          dicKeys.forEach((quality) => {
            if (!filesDictionary[quality]) {
              return;
            }
            const { type, file } = filesDictionary[quality];
            if (!file || type !== FILE) {
              return;
            }
            const selectedName = file.name;
            let uploadedName;
            if (uploadedFilesDictionary[quality]) {
              uploadedName = uploadedFilesDictionary[quality].name;
            }
            if (!(file instanceof File) || selectedName === uploadedName) {
              return;
            }
            this.$store.dispatch('uploadManager/startUpload', {
              apiHost: host,
              apiPrefix: prefix,
              entityId: this.$route.params.id,
              files: [file],
              token,
              acceptedFiles,
              contentType,
              quality,
            });
            uploadedFilesDictionary[quality] = filesDictionary[quality];
          });
        }
      };
      if (!this.coverIsChanged) {
        this.saveRequest().then((response) => {
          this.$_successSave();
          dispatchStartUpload(response.data.content_type);
        }).catch((error) => {
          this.$_errorSave(error);
          console.error('Error in update video query', error);
        });
      } else if (!this.entity.cover) {
        axios.all([this.deleteCoverRequest(), this.saveRequest()]).then(axios.spread((cover, entity) => {
          if (Math.round(cover.status / 100) === 2 && Math.round(entity.status / 100) === 2) {
            this.$_successSave();
            dispatchStartUpload(entity.data.content_type);
          } else {
            this.$_showError('Error in data saving');
          }
        }));
      } else {
        axios.all([this.saveCoverRequest(), this.saveRequest()]).then(axios.spread((cover, entity) => {
          if (Math.round(cover.status / 100) === 2 && Math.round(entity.status / 100) === 2) {
            this.$_successSave();
            dispatchStartUpload(entity.data.content_type);
          } else {
            this.$_showError('Error in data saving');
          }
        }));
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// Edit.vue?16814235